module.exports = __webpack_public_path__ + "img/scooter-processing-2x.e29966bf.png";